import { Permission, SecurityScope } from '../../auth/auth.model';
import { AuthService } from '../../auth/auth.service';
import { CoachingEventStatus } from '../../coaching-base/general';
import { epicDependencies } from '../../store';

import { EnabledActions, RootState } from './commitment.state';

export enum CommitmentState {
    NEW_DRAFT = 0,
    DRAFT,
    DRAFT_DISPUTED_SENDER,
    DRAFT_DISPUTED_RECEIVER,
    ACTIVE,
    ACTIVE_EDIT,
    ACTIVE_DRAFT_VERSION,
    UPDATING,
    CLOSE,
}

function getCommitmentState(state: RootState): CommitmentState {
    const commitment = state.commitment;
    if (!commitment) {
        return null;
    }

    const approval = state.draft
        ? state.draft.approval || state.draft.previousApproval
        : state.approval;

    if (
        (commitment.statusId === CoachingEventStatus.DRAFT ||
            commitment.statusId === CoachingEventStatus.DISPUTED) &&
        approval &&
        approval.approved === false
    ) {
        return state.isReadWrite === false
            ? CommitmentState.DRAFT_DISPUTED_RECEIVER
            : CommitmentState.DRAFT_DISPUTED_SENDER;
    } else if (
        (commitment.statusId === CoachingEventStatus.ACTIVE &&
            commitment.draftAndApproval &&
            commitment.draftAndApproval.isOriginalCommitment) ||
        (commitment.statusId === CoachingEventStatus.ACTIVE &&
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            (approval == null || (approval && approval.approved)))
    ) {
        if (!state.isEditing) {
            return CommitmentState.ACTIVE;
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        } else if (
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            state.mirrorCopyAlertInfo &&
            state.mirrorCopyAlertInfo.isOriginalCommitment
        ) {
            return CommitmentState.ACTIVE_DRAFT_VERSION;
        } else if (
            state.mirrorCopyAlertInfo &&
            !state.mirrorCopyAlertInfo.isOriginalCommitment
        ) {
            return CommitmentState.DRAFT;
        } else {
            return CommitmentState.ACTIVE_EDIT;
        }
    } else if (
        commitment.statusId === CoachingEventStatus.UPDATING ||
        (approval && approval.approved == null)
    ) {
        return CommitmentState.UPDATING;
    } else if (commitment.statusId === CoachingEventStatus.CLOSED) {
        return CommitmentState.CLOSE;
    } else if (commitment.commitmentId === undefined) {
        return CommitmentState.NEW_DRAFT;
    } else if (
        commitment.statusId === CoachingEventStatus.DRAFT &&
        (commitment.commitmentId == null || commitment.commitmentId)
    ) {
        return CommitmentState.DRAFT;
    }
}

export function enabledActionsState(state: RootState): EnabledActions {
    const commitmentState = getCommitmentState(state);

    // TODO FIXME. this can be done better
    const service = epicDependencies.injector.get<AuthService>(AuthService);

    // TODO add same checks to api endpoints
    const teamsCallCanStartCall = service.user.hasPermission(
        Permission.TEAMS_CALL_CREATE_CALL,
        SecurityScope.COACHING_COMMITMENT,
    );

    // TODO add same checks to api endpoints
    const teamsCallHasChat = service.user.hasPermission(
        Permission.TEAMS_CALL_CREATE_CHAT,
        SecurityScope.COACHING_COMMITMENT,
    );
    const teamsCallCanStartChat =
        state.commitment?.commitmentId != null &&
        state.commitment?.statusId === CoachingEventStatus.ACTIVE;

    return {
        publish:
            commitmentState === CommitmentState.DRAFT_DISPUTED_SENDER ||
            commitmentState === CommitmentState.NEW_DRAFT ||
            commitmentState === CommitmentState.DRAFT ||
            commitmentState === CommitmentState.ACTIVE_EDIT,
        save:
            commitmentState === CommitmentState.DRAFT_DISPUTED_SENDER ||
            commitmentState === CommitmentState.ACTIVE_EDIT ||
            commitmentState === CommitmentState.NEW_DRAFT ||
            commitmentState === CommitmentState.DRAFT,
        close:
            commitmentState === CommitmentState.ACTIVE ||
            commitmentState === CommitmentState.ACTIVE_EDIT ||
            commitmentState === CommitmentState.ACTIVE_DRAFT_VERSION,
        delete:
            commitmentState === CommitmentState.DRAFT ||
            commitmentState === CommitmentState.DRAFT_DISPUTED_SENDER,
        edit: commitmentState === CommitmentState.ACTIVE,
        teamsCallCanStartCall,
        teamsCallHasChat,
        teamsCallCanStartChat,
    };
}

export function allowedAndEnabledActionsReducer(state: RootState): RootState {
    let nextEnabledActions = enabledActionsState(state);

    if (state.isReadOnly) {
        nextEnabledActions = {
            ...nextEnabledActions,
            publish: false,
            save: false,
            close: false,
            delete: false,
            edit: false,
        };
    }

    return {
        ...state,
        enabledActions: nextEnabledActions,
    };
}
